import React, { Component } from 'react';
import { FormGroup, Col, Form, ControlLabel } from 'react-bootstrap';
import ScheduledAllocationEvents from './ScheduledAllocationEvents';
import Select from '../atoms/forms/Select';
import ModalWrapper from './ModalWrapper';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

// This component is the display of ready for allocation modal, which is opened when
// user clicks on Ready for Allocation
// The modal displays:
// (1) Ready for Allocation value (drop down with values Yes and No)
// (2) Reason for Change (drop down with a set of reasons)
// (3) Other reason if (2) has value 'Other'
export default class DisplayRowAllocation extends Component {
  constructor(props) {
    super(props);
    this.getReasonValue = this.getReasonValue.bind(this);
  }

  getReasonValue() {
    // make reason case-insensitive
    // will be useful while handling bulk updates using CSV
    for (let i = 0; i < this.props.reasonValues.length; i++) {
      if (
        this.props.reasonValue.toLowerCase() ===
        this.props.reasonValues[i].toLowerCase()
      ) {
        return this.props.reasonValues[i];
      }
    }
    return 'Other';
  }

  render() {
    // array of possible reasons for changing allocation value (from Yes -> No or No -> Yes)
    return (
      <tr>
        <td>
          {this.props.prettyName}
          {this.props.tooltip ? (
            <InfoTooltipIcon tooltipText={this.props.tooltip} />
          ) : (
            ''
          )}
        </td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.value}
        </td>
        <ModalWrapper
          show={this.props.edit}
          title={this.props.prettyName}
          handleClose={this.props.handleClose}
          handleSave={this.props.handleSave}
          handleSchedule={this.props.handleSchedule}
        >
          <Form horizontal>
            <FormGroup controlId="formHorizontalAllocation">
              <Col componentClass={ControlLabel} sm={2}>
                {this.props.prettyName}
              </Col>
              <Col sm={10}>
                <select
                  name="allocationValue"
                  onChange={this.props.handleChange}
                  value={this.props.allocationValue}
                  className="form-control"
                  required
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </Col>
            </FormGroup>
            <FormGroup controlId="formHorizontalReason">
              <Col componentClass={ControlLabel} sm={2}>
                Reason for Change
              </Col>
              <Col sm={10}>
                <Select
                  name="reasonValue"
                  placeholder="Choose Reason"
                  onChange={this.props.handleChange}
                  value={this.getReasonValue()}
                  required
                  options={this.props.reasonValues.map((r) => ({
                    label: r,
                    value: r,
                  }))}
                />
              </Col>
            </FormGroup>
            <br />
            {/* provide ability to specify reason only if user selected 'Other' above */}
            {(this.props.reasonValue === 'Other' ||
              this.getReasonValue() === 'Other') && (
              <FormGroup>
                <label htmlFor="formOther" style={{ marginLeft: 10 }}>
                  Other Reason:
                  {'\u00A0\u00A0'}
                </label>
                <input
                  type="text"
                  name="other"
                  id="formOther"
                  onChange={this.props.handleChange}
                  placeholder={this.props.reasonValue}
                  title=""
                  size={65}
                />
              </FormGroup>
            )}
          </Form>
          <font className="mandatory">{this.props.errorString}</font>
          {/* ScheduledAllocationEvents is a component specifically designed to display scheduled
                            changes to both allocation value and the reason for change
                            They show up as below:

                            Scheduled Date of change
                            allocation value ; reason

                          */}
          <ScheduledAllocationEvents
            events={this.props.events}
            id={this.props.id}
            deleteScheduleAction={this.props.deleteScheduleAction}
          />
        </ModalWrapper>
      </tr>
    );
  }
}
